import 'flickity/dist/flickity.pkgd.js';
import Flickity from 'flickity';
import 'viewerjs/dist/viewer.min.js';
import 'jquery-viewer/dist/jquery-viewer.min.js';

import { cookieConsent } from './scripts/cookie/cookieConsent';
import { deleteCookie } from './scripts/cookie/deleteCookie';
import { fullWidthVideoPlayerFile } from './scripts/video/fullWidthVideoPlayerFile';
import { videoPopupPlayerFile } from './scripts/video/videoPopupPlayerFile';
import { delayHomeBannerVideoFile } from './scripts/video/delayHomeBannerVideoFile';
import { headerScripts } from './scripts/header/headerScripts';
import { stickyMenu } from './scripts/header/stickyMenu';
import { loadMore } from './scripts/load-more/loadMore';
import { formScripts } from './scripts/form/formScripts';
import { cardSectionGridSlider } from './scripts/card/cardSectionGridSlider';
import { cardSectionSlider } from './scripts/card/cardSectionSlider';
import { logoSlider } from './scripts/logo/logoSlider';
import { logoSectionGridSlider } from './scripts/logo/logoSectionGridSlider';
import { gallerySectionSlider } from './scripts/gallery/gallerySectionSlider';
import { jqueryViewer } from './scripts/gallery/jqueryViewer';
import { editorContentAdditions } from './scripts/misc/editorContentAdditions';
import { testimonialSlider } from './scripts/testimonial/testimonialSlider';
import { testimonialGridSlider } from './scripts/testimonial/testimonialGridSlider';

// Flickity.prototype._createResizeClass = function() {
//   this.element.classList.add('flickity-resize');
// };

// Flickity.createMethods.push('_createResizeClass');

// var resize = Flickity.prototype.resize;
// Flickity.prototype.resize = function() {
//   this.element.classList.remove('flickity-resize');
//   resize.call( this );
//   this.element.classList.add('flickity-resize');
// };

export default {
  init() {
    // JavaScript to be fired on all pages
    Flickity.defaults.dragThreshold = 3;
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    // Check the possibility to initialize of sliders inline in the php to reduce the amount of scripts files
    logoSlider();
    cookieConsent();
    deleteCookie('PREF');
    headerScripts();
    stickyMenu();
    logoSectionGridSlider();
    formScripts();
    cardSectionGridSlider();
    cardSectionSlider();
    gallerySectionSlider();
    jqueryViewer('.gallery-images-viewer-v2');
    jqueryViewer('.gallery-images-viewer-v1');
    fullWidthVideoPlayerFile();
    videoPopupPlayerFile();
    delayHomeBannerVideoFile();
    editorContentAdditions();
    loadMore();
    testimonialGridSlider();
    testimonialSlider();
    customModalScripts();
    headerAnimation();
    // testFunc();
    // Check the possibility to initialize of sliders inline in the php to reduce the amount of scripts files

    setTimeout(function(){
      updateSliderButtons()
    }, 500);

    //This script to be moved to a separate file as per other scripts
    $(document).on('click', '.slider-button-left', function () {
      var $section = $(this).closest('.section-inner-wrp');
      $section.find('.flickity-button.previous').click();
    });

    $(document).on('click', '.slider-button-right', function () {
      var $section = $(this).closest('.section-inner-wrp');
      $section.find('.flickity-button.next').click();
    });
    //This script to be moved to a separate file as per other scripts
  },
};

$(window).bind('load resize', function() {
  setTimeout(function(){
    cardSectionGridSlider();
  }, 500);
});

// function testFunc() {
//   $('.disable-play-video').on('click', function () {
//   console.log('video play disabled');
//   $('#fixed-cookie-logo').slideUp('slow', function() {
//     $('#cookie-consent-section').slideDown('slow');
//   });
// });
// }



$(window).on('resize', function () {
  $('.cards-section.slider .cards-wrp, .cards-section.grid .cards-wrp'
  ).flickity('resize');

  setTimeout(function(){
    updateSliderButtons()
  }, 500);
  // flickity resize to work when specific amount of pixels are resized eg: now at 10px
  const previousWidth = $(window).data('previousWidth') || $(window).width();
  const currentWidth = $(window).width();
  const resizeDelta = Math.abs(currentWidth - previousWidth);

  if (resizeDelta > 10) {
    $('.flickity-viewport').css('height', '400px');
  }

  $(window).data('previousWidth', currentWidth);
  // flickity resize to work when specific amount of pixels are resized eg: now at 10px

  // set header height to sticky overlay
  $('.sticky-overlay').outerHeight($('.header').outerHeight());
  $('.main > section:first-child:not(".news-listing-section, .home-banner-section, .header-variation-active, .fcp-section, .home-links-section"), .main > section.page-banner-section .banner-heading-wrp').css('padding-top', $('.header').outerHeight());
});

$(window).on('load', function () {
  $('.carousel .carousel-resize').flickity('resize');

  cardSectionGridSlider();
});

//This script to be moved to a separate file as per other scripts
function updateSliderButtons() {
  $('.carousel').each(function () {
    const $section = $(this);
    const hasFlickity = $section.find('.flickity-button').length > 0;
    const hasCustomButtons = $section.find('.slider-buttons-wrp').length > 0;

    //Add custom buttons if Flickity buttons are present and custom buttons are missing
    if (hasFlickity && !hasCustomButtons) {
      const $wrapper = $('<div>', { class: 'slider-buttons-wrp' });

      $.each(['left', 'right'], function (index, dir) {
        $('<span>', {
          class: 'slider-button slider-button-' + dir,
        }).appendTo($wrapper);
      });

      $section.find('.slider-buttons-wrp-outer').append($wrapper);
    }

    //Remove custom buttons if Flickity buttons are missing
    if (!hasFlickity && hasCustomButtons) {
      $section.find('.slider-buttons-wrp').remove();
    }
  });
}
// This script to be moved to a separate file as per other scripts

function customModalScripts() {
  // const popupTrigger = $('.links-wrp > .link-item-wrp > .link-item');
  const popupOneSelector = $('.popup-level-one');

  $(popupOneSelector).each(function () {
    $(this).on('shown.bs.modal', function () {
      $('body').addClass($(this).parent().hasClass('green') ? 'popup-green' : 'popup-red');
    });
  });

  // Remove class from the body when the modal is fully hidden
  $(popupOneSelector).on('hidden.bs.modal', function () {
    if ($(popupOneSelector).hasClass('show') === false) {
      $('body').removeClass('popup-green popup-red');
    }
  });

  // Close button for level two
  $('.popup-level-two .close').on('click', function () {
    $(this).closest('.popup-level-two').modal('hide');
  });
}

function headerAnimation() {
  const header = $('.header');

  setTimeout(function(){
    header.css('transform', 'translateY(0)');
  }, 500);
}